export const BASKET_MODAL_CONTENT_LABEL = 'Add to Basket Modal';
export const BASKET_MODAL_BUTTON_CONTINUE = 'Continue shopping';
export const BASKET_MODAL_BUTTON_CTA = 'Go to basket';
